// Resolve the correct option index for an AI course quiz question across stored formats.
export const correctIndex = (q) => {
  const opts = q.options || [];
  if (typeof q.correctAnswer === 'number') return q.correctAnswer;
  const flagged = opts.findIndex((o) => o && typeof o === 'object' && o.isCorrect);
  if (flagged >= 0) return flagged;
  const ca = q.correctAnswer !== undefined ? q.correctAnswer : q.correct_answer;
  if (typeof ca === 'number') return ca;
  return opts.findIndex((o) => (typeof o === 'object' && o ? o.text : o) === ca);
};
